import { Injectable, Injector } from '@angular/core';
import { ActivityModel } from '../models/activity.model';
import { ApiInterface, ApiService } from '../../api/api.service';

@Injectable()
export class ActivityService extends ApiService implements ApiInterface {

    public restEndpoint = '{entity}/{entityId}/activities';
    public model        = ActivityModel;
    public collection;

    constructor(injector: Injector) {
        super(injector);

    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/activities/services/activity.service.ts